import { DEFAULT_WEATHER_PARAMS } from "./constants";
import { FetchWeatherArgs } from "./types";

export const paramsToKey = (
  suffix: "daily" | "hourly",
  params: FetchWeatherArgs["params"] = DEFAULT_WEATHER_PARAMS,
): string => {
  const { start_date, end_date, latitude, longitude } = params;
  return `${start_date}-${end_date}-${latitude}-${longitude}-${suffix}`;
};
